import { Component, Input, OnInit } from '@angular/core';
import { Study } from 'src/app/data/study';
import { AlertService } from 'src/app/services/alert.service';
import { BookService } from 'src/app/services/book.service';

@Component({
  selector: 'app-info-study',
  templateUrl: './info-study.component.html',
  styleUrls: ['./info-study.component.css']
})
export class InfoStudyComponent implements OnInit {

  opened = false;
  mail: string = '';
  //@Input() mail!: string;
  //@Output('sendMail') sendMailEmitter = new EventEmitter<string>();
   bookStudies: Study[] = []; 
   locator: string = ""; 

  showMail:boolean = false;


  constructor(
    private alertService: AlertService,
  ) { }

  ngOnInit(): void {
  }

  openModal(locator: string, book: Study[]) {
    this.bookStudies = book;
    this.locator = locator;
    this.opened = true;
  }

  close() {
    
    this.opened = false;
  }



}

